import DatePicker from "./vue/datePicker/DatePicker";

// defining this here so the DatePicker import gets used
customElements.define("sky-datepicker", DatePicker);

export function closeModal(element: JQuery<HTMLElement>)
{
    const control = element.closest("sky-datepicker");
    if (control.length > 0 && (control[0] as any).closeModal)
    {
        (control[0] as any).closeModal()
    }
}